import React from 'react';
import Button from '@atlaskit/button/new';
import { useIntl } from '@atlassian/jira-intl';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { InvokedFrom, ResourceSuggestion } from '../../controllers/context.tsx';
import messages from './messages.tsx';

type FooterProps = {
	draftSuggestions: ResourceSuggestion[] | undefined;
	onAcceptAllSuggestions: () => void;
	invokedFrom: InvokedFrom;
};

export const Footer: React.FC<FooterProps> = ({
	draftSuggestions,
	onAcceptAllSuggestions,
	invokedFrom,
}) => {
	const { formatMessage } = useIntl();

	if (!draftSuggestions || draftSuggestions.length === 0) {
		return null;
	}

	// We don't show a CTA button in GIC
	if (
		invokedFrom === 'globalIssueCreate' &&
		expVal('proactive_similar_work_items_in_gic_experiment', 'isEnabled', false)
	) {
		return null;
	}

	return (
		<Button
			type="button"
			testId="ai-related-issues.ui.footer.accept-all-loading-button"
			onClick={onAcceptAllSuggestions}
			spacing="compact"
			appearance="primary"
		>
			{formatMessage(messages.linkAll)}
		</Button>
	);
};
